import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-left-menu',
  templateUrl: './side-left-menu.component.html',
  styleUrl: './side-left-menu.component.scss',
})
export class SideLeftMenuComponent implements OnInit, OnDestroy {
  @Input() menuSliderLeft = false;
  @Output() menuSliderLeftChange = new EventEmitter<boolean>();

  @ViewChild('sideMenuWrapper') sideMenuWrapper: ElementRef;

  private isAdmin = false;



  tabMenuLeft: boolean = false;
  menuItems: any = [];
  menuItem: any = {};
  menuItemsInfo: any = [
    {
      label: 'Info',
      collapseId: 'Info',
      iconClass: 'fa-solid fa-circle-info',
      subLinks: [
        {
          label: 'Roles',
          routerLink: '/roles',
          iconClass: 'fa-solid fa-globe side_icon',
        },
        {
          label: 'How To Earn',
          routerLink: '/how-to-earn',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Rental',
          routerLink: '/rental-system-terms-and-conditions',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Terms',
          routerLink: '/policies',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'kachiing Questions',
          routerLink: '/faq',
          iconClass: 'fa-solid fa-question',
        },
        {
          label: 'Version 1.0.0',
          routerLink: '/faq',
          iconClass: 'fa-solid fa-question',
        },
      ],
    },
    {
      title: 'Main Pages',
    },
    {
      label: 'Forum',
      routerLink: '/forum',
      iconClass: 'fa-solid fa-comments',
    },
    // {
    //   label: 'Poll',
    //   routerLink: '/forum/poll',
    //   iconClass: 'fa-solid fa-square-poll-vertical',
    //   condition: 'admin',
    // },
    {
      label: 'Giveaway',
      routerLink: '/giveaway',
      iconClass: 'fa-solid fa-circle-dollar-to-slot',
      //condition: 'admin',
    },
    {
      label: 'Share News',
      routerLink: '/news',
      iconClass: 'fa-solid fa-newspaper',
    },
    {
      title: 'Other Pages',
      condition: 'auth',
    },
    {
      label: 'Kachiing Biz',
      routerLink: '/biz',
      iconClass: 'fa-solid fa-store',
    },
  ];
  imgUrl = environment.ImageUrl;
  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    public auth: AuthServiceService,
    private local: LocalServiceService,
    public sharedService: SharedService,
    public roleService: RoleService,
  ) { }
  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN')
    })

  }


  /*************************** Code related to keywords of subcagtegory******************************************* */

  public selectedCategoryTypesNameSuggestion = []



  public keywordsSelectedSubCategory = null;
  public keywordSSelectedSubCategoryKeywordList: string[] = [];
  public currentInputtingKeyword: string = '';


  private _getKeywordsOfCurrentSubCategory() {

    this.auth.getKeywordsOfSubCategory(this.keywordsSelectedSubCategory.id)
      .subscribe({
        next: data => {
          this.keywordSSelectedSubCategoryKeywordList = data.body;
        }
      })
  }

  @ViewChild('editSubCategoryKeywordModal')
  public editSubCategoryKeywordModal: ElementRef;

  public openEditSubCategoryKeywordModal(subCategory) {
    this.keywordsSelectedSubCategory = subCategory;
    this._getKeywordsOfCurrentSubCategory();
    this.modalService.open(this.editSubCategoryKeywordModal, { size: 'md' })
    this.auth.getTypesOfCategory(subCategory.id)
      .subscribe({
        next: (data: any) => {
          this.selectedCategoryTypesNameSuggestion = data.data.map(type => type.name)

        }
      })
  }
  public removeKeywordFromSelectedSubCategory(keyword: string) {
    this.local.confirmYesNo({
      title: "Remove keyword",
      text: `remove keyword ${keyword} from ${this.keywordsSelectedSubCategory.label}?`,
      icon: 'info'
    }).then(
      c => {
        if (c.isConfirmed) {
          this.auth.removeKeywordFromSubCategory(this.keywordsSelectedSubCategory.id, keyword)
            .subscribe({
              next: () => {
                this.toastr.success("Removed");
                this._getKeywordsOfCurrentSubCategory();
              },
              error: err => {
                console.error(err);
                this.toastr.error("Something went wrong while editing keywords")
              }
            }
            )

        }
      }
    )


  }
  private _addKeywordToSelectedSubCategory() {
    this.auth.addKeywordToSubCategory(this.keywordsSelectedSubCategory.id, this.currentInputtingKeyword)
      .subscribe({
        next: () => {
          this.currentInputtingKeyword = ''
          this.toastr.success("Added!");
          this._getKeywordsOfCurrentSubCategory();

        },
        error: err => {
          console.error(err);
          this.toastr.error("Something went wrong while editing keywords")
        }
      }
      )
  }
  public addKeywordToSelectedSubCategory() {
    this.auth.getSubCategoriesByKeyword(this.currentInputtingKeyword).subscribe({
      next: (data) => {
        if (data.body.length) {
          this.local.confirmYesNo({ text: `There are other(${data.body.length}) subcategories that use this keyword`, title: 'Are you sure you want to add keyword', icon: 'warning' })
            .then(r => {
              if (r.isConfirmed) {
                this._addKeywordToSelectedSubCategory();
              }
            })

        } else {
          this._addKeywordToSelectedSubCategory();

        }
      }
    })


  }
  /********************************************************************************************************************************* */
  icons: any = {
    'Food & Beverage': 'fa-solid fa-burger',
    'Home Dining': 'fa-solid fa-house-user',
    'Fitness': 'fa-solid fa-person-skating',
    'Pets': 'fa-solid fa-paw',
    'Education': 'fa-solid fa-school',
    'Child Care': 'fa-solid fa-child',
    'Home Improvement': 'fa-solid fa-house-chimney',
    'Beauty & Grooming': 'fa-solid fa-b',
    'Automobile & Transport': 'fa-solid fa-car',
    'Games and Hobbies': 'fa-solid fa-gamepad',
    'Others': 'fa-solid fa-ellipsis'
  }
  private _roleSubscription: Subscription | null = null;
  fetch() {
    this.auth
      .getAllMemberCategorieRelationship()
      .subscribe((response: ApiResponse) => {
        const menuItem = [];
        response.body.map(async (e) => {
          await menuItem.push({
            label: e.name,
            collapseId: `menu-${e.id}`,
            iconClass: this.icons[e.name],
            image: e.image,
            subLinks: e.subCategory.map((sub) => ({
              id: sub.categorieChildId,
              label: sub.categoryName,
              routerLink: `category/${sub.slug}`,
            })),
          });
        });
        this.menuItems = [...menuItem, ...this.menuItems];
      });


    this.local.getUserDetailsObserver().subscribe((user) => {

      var isLogin;
      if (user?.id) {
        isLogin = 1;
      } else {
        isLogin = 0;
      }
      this.menuItemsInfo = this.menuItemsInfo.map((item) => {

        let condition = true
        if (item.condition === 'auth') {
          condition = isLogin;
        } else if (item.condition === 'admin') {
          //console.log('checking is the user is admin', this.isUserAdmin)
          condition = isLogin && this.isUserAdmin;
        }
        return {
          ...item,
          condition
        };
      });
    });
  }


  ngOnChanges(changes): void {
    if (changes['menuSliderLeft'] && this.menuSliderLeft && !this.menuItems.length) {
      this.fetch()
    }
  }
  public get isUserAdmin(): boolean {
    return this.isAdmin;
  }
}
